import React from 'react';
import { Link } from 'react-router-dom';
import { Wrench } from 'lucide-react';

const MaintenancePage = ({ message }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-10 max-w-md w-full text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-[#1FA7A1]/10 rounded-full p-5">
            <Wrench className="h-12 w-12 text-[#1FA7A1]" />
          </div>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-3">Under Maintenance</h1>
        <p className="text-gray-500 mb-8 leading-relaxed">
          {message || 'We are currently performing maintenance. Please check back soon.'}
        </p>
        <Link
          to="/clinic-registration"
          className="block w-full bg-[#1FA7A1] text-white rounded-xl px-6 py-3 font-medium hover:bg-[#178a85] transition-colors"
          data-testid="register-clinic-btn"
        >
          Register Your Clinic
        </Link>
        <p className="text-xs text-gray-400 mt-4">
          Already registered?{' '}
          <Link to="/clinic-login" className="text-[#1FA7A1] hover:underline" data-testid="clinic-login-link">
            Clinic Login
          </Link>
        </p>
      </div>
    </div>
  );
};

export default MaintenancePage;
